module.exports = __webpack_public_path__ + "img/bg_function03_2_t.3ab6b498.png";